// Which screen may be drawn, given what the last check of the account concluded.
//
// The address bar, Back and Forward, and a few shortcuts inside the app can all ask for a screen.
// Asking is not enough: before this, an unpaid client who was shown the paywall could press Back
// and be handed the dashboard, because the address said /dashboard and nothing looked at the
// account again (item 29). Every screen the app draws now goes through gateView.

// Screens for somebody whose account has been checked and found in good standing.
export const SIGNED_IN_VIEWS = new Set(['dashboard', 'stats', 'messages', 'privacy', 'admin']);

// Screens that say why somebody is not let in yet. Each is only for the person it was decided for.
export const GATE_VIEWS = new Set([
  'paywall', 'fitness-bridge', 'payment-confirming', 'pending-approval', 'suspended', 'rejected',
]);

// What a check of the account concluded, from the screen it sent the person to:
// 'in', the name of a gate screen, or null (nobody signed in, or nothing decided yet).
export const standingFor = (view) => {
  if (SIGNED_IN_VIEWS.has(view)) return 'in';
  if (GATE_VIEWS.has(view)) return view;
  return null;
};

// Screens for somebody not signed in. Somebody whose account has been checked (in, or held at a gate)
// is sent to their own screen instead: the phone's Back to the welcome page and then "Sign up" ran
// sign-up over their own account and overwrote their answers (owner, 20 October 2026). Signing out
// first opens them again. Somebody signed in with no Fitness answers yet (a first Google sign-in) has
// no standing and still reaches sign-up.
export const SIGNED_OUT_VIEWS = new Set(['home', 'onboarding', 'login']);

export const viewAllowed = (view, standing) => {
  if (SIGNED_IN_VIEWS.has(view)) return standing === 'in';
  if (SIGNED_OUT_VIEWS.has(view)) return standing == null;
  if (GATE_VIEWS.has(view)) return standing === view;
  return true;
};

// The screen to draw when `wanted` is asked for. A refused request gets the screen the account
// check decided on: the dashboard for somebody who is in, their gate for somebody held at one,
// the welcome screen for anybody else.
export const gateView = (wanted, standing) => {
  if (viewAllowed(wanted, standing)) return wanted;
  if (standing === 'in') return 'dashboard';
  return GATE_VIEWS.has(standing) ? standing : 'home';
};
